// removed by extract-text-webpack-plugin
module.exports = {"content":"_3nYYbQkd9N1EVzdX"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/PopupContent.pcss
// module id = 490
// module chunks = 1